// extracted by mini-css-extract-plugin
module.exports = {"grid":"m_J","aligned":"m_K","image":"m_L","content":"m_M"};